var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLChevronRight = function SvgLChevronRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_1982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C25.3048 40 30.392 37.8922 34.142 34.142C37.892 30.3918 40 25.3044 40 20C40 14.6956 37.8922 9.608 34.142 5.858C30.3918 2.108 25.3044 0 20 0C14.6956 0 9.60803 2.1078 5.85803 5.858C2.10803 9.6082 0 14.6956 0 20C0 25.3044 2.10783 30.392 5.85803 34.142C9.60823 37.892 14.6956 40 20 40ZM9.99988 19.9592C9.9938 19.5248 10.1641 19.1061 10.4719 18.7998L17.0563 12.2358C17.6844 11.6062 18.7047 11.6062 19.3344 12.2343C19.964 12.8624 19.9641 13.8827 19.3359 14.5124L15.4797 18.3718L28.4001 18.3718C29.2845 18.3718 30.0001 19.089 30.0001 19.9718C30.0001 20.8561 29.2845 21.5718 28.4001 21.5718L15.4437 21.5718L19.3359 25.464C19.9656 26.0936 19.9656 27.114 19.3359 27.7436C18.7063 28.3733 17.686 28.3733 17.0563 27.7436L10.4718 21.1796C10.1687 20.8781 9.99845 20.4672 9.99988 20.0406V19.9592Z",
    fill: "#E2E7EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_1982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 -1 40 40)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLChevronRight, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/LChevronRight.58264dd0.svg";
export { ForwardRef as ReactComponent };